module.exports = __webpack_public_path__ + "img/Website video-post.db4331d8.jpg";